type EmbedField = { label: string; value: string };

type EmbedProps = {
  title?: string;
  desc?: string;
  fields?: EmbedField[];
};

export function Embed({ title, desc, fields }: EmbedProps) {
  return (
    <div className="embed">
      {title && <div className="e-title">{title}</div>}
      {desc && <div className="e-desc">{desc}</div>}
      {fields && (
        <div className="e-fields">
          {fields.map((f, i) => (
            <div key={i}>
              <b>{f.label}</b>
              <span>{f.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
